module.exports = __webpack_public_path__ + "img/play_your_way_graphic.1a4649af.png";